<template>

  <tech-header></tech-header>

    <div class="page mt-3">

        <kt-datatable
            :model="techModel"
            :data="listArray"
            :meta="{ tableClass: '-table-bordered' }"
        >
        <template #header_select="scope">
          <div class="form-check">
            <input 
              class="form-check-input" 
              type="checkbox" 
              :checked="selectAll"
              @change="toggleSelectAll"
              @click.stop
              title="Select all on this page"
            />
          </div>
        </template>
        
        <template #view_select="scope">
          <div class="form-check">
            <input 
              class="form-check-input" 
              type="checkbox" 
              :checked="selectedRows.includes(scope.row.Id)"
              @change="toggleRowSelection(scope.row.Id)"
              @click.stop
            />
          </div>
        </template>
    
        <template #view_actions="scope">

          <div class="btn-group">
            <button class="btn btn-sm btn-outline-primary form-control" @click="editRecord(scope.row.Id)">
              <i class="fa fa-edit"></i>
              <!-- Edit -->
            </button>
            <button v-if="isSysAdmin" class="btn btn-sm btn-outline-info form-control" @click="impersonate(scope.row.Id)">
              <i class="fa fa-user-secret"></i>
              <!-- Impersonate -->
            </button>
            <button class="btn btn-sm btn-outline-danger form-control" @click="deleteRecord(scope.row.Id)">
              <i class="fa fa-trash"></i> 
              <!-- Remove -->
            </button>
            
          </div>

          <!-- 
          <kt-dropmenu v-model:visible="actionDropdown['row_' + scope.row.Id]">
            <template #button>
              <button
                  class="btn -btn-outline-primary btn-sm"
                  @click="actionDropdown['row_' + scope.row.Id] = !actionDropdown['row_' + scope.row.Id]"
              >
                <span><i class="fas fa-ellipsis-v"></i></span>
              </button>
            </template>
            <template #dropmenu>
              <ul class="dropdown-menu show">
                <li>
                  <label class="dropdown-item">
                    <button class="btn btn-sm btn-outline-primary form-control" @click="editRecord(scope.row.Id)">
                      <i class="fa fa-edit"></i> Edit
                    </button>
                  </label>
                </li>
                <li>
                  <label class="dropdown-item">
                    <button class="btn btn-sm btn-outline-danger form-control" @click="deleteRecord(scope.row.Id)">
                      <i class="fa fa-trash"></i> Remove
                    </button>
                  </label>
                </li>
              </ul>
            </template>
          </kt-dropmenu>
          -->
          <!--
            <button
                @click="editRecord(scope.row.Id)"
                class="btn -btn-outline-primary btn-sm"
            >
                <span><i class="fas fa-ellipsis-v"></i></span>
            </button>
            -->
        </template>


        <template #after-search="scope">
            <div class="-btn-group">
          <button @click="refresh()" 
              class="btn btn-sm btn-outline-secondary me-2"
          >Refresh <i class="fa fa-sync"></i></button>

          <button @click="newRecord()" 
              class="btn btn-sm btn-outline-primary"
          >New <i class="fa fa-plus"></i></button>
          </div>
        </template>

        <template #view_string="scope">
              <router-link :to="'/tech/edit/' + scope.row.Id">
                {{ scope.value }}
              </router-link>
        </template>
        
        <template #under-header>
          <!-- Bulk Actions Toolbar -->
          <div v-if="selectedRows.length > 0" class="mb-0 p-2 actions-row">
            <div class="d-flex align-items-center gap-2">
              <span class="fw-bold text-primary">{{ selectedRows.length }} selected</span>
              <button 
                class="btn btn-sm btn-outline-danger"
                @click="showDeleteModal = true"
                title="Delete Selected"
              >
                <i class="fas fa-trash"></i> Delete
              </button>
              <button 
                class="btn btn-sm btn-outline-secondary me-auto"
                @click="clearSelection"
              >
                Clear Selection
              </button>
            </div>
          </div>
        </template>
        
        </kt-datatable>
        
        <!-- Bulk Delete Confirmation Modal -->
        <kt-modal
          :visible="showDeleteModal"
          title="Confirm Bulk Delete"
          @dismiss="showDeleteModal = false"
        >
          <template #body>
            <div class="container-fluid">
              <p class="text-danger mb-3">
                <i class="fas fa-exclamation-triangle"></i>
                Are you sure you want to delete {{ selectedRows.length }} technician(s)?
              </p>
            </div>
          </template>
          <template #footer>
            <div class="kt-modal-actions">
              <button class="btn btn-outline-secondary" @click="showDeleteModal = false">
                <X :size="16" class="me-1" />Cancel
              </button>
              <button class="btn btn-danger" @click="confirmBulkDelete">
                <Trash2 :size="16" class="me-1" />Delete
              </button>
            </div>
          </template>
        </kt-modal>

        <!-- edit / new / etc... -->
        <router-view name="modal"></router-view>

    </div>
    
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from 'vue-router';
import { storeToRefs } from "pinia";

import Events from "@/services/Emitter";
import { useTechStore } from '@/stores/TechStore';
import { useAppStore } from '@/stores/AppStore';
import { usePermissions } from '@/composables/usePermissions';
import TokenHelper from '@/services/TokenHelper';
import ApiService from '@/services/ApiService';

import KtModal from '@/components/UI/KtModal.vue';
import { X, Trash2 } from 'lucide-vue-next';
import KtDatatable from "@/components/UI/KtDatatable.vue";
import { KtDatatableModelProp, KtDatatableData } from "../UI/KtDataTable";
import KtDropmenu from "@/components/UI/KtDropmenu.vue";
import TechHeader from "./TechHeader.vue";

const router = useRouter();
const techStore = useTechStore();
const { list } = storeToRefs(techStore);

// Convert the record to an array for the datatable
const listArray = computed(() => Object.values(list.value));

const actionDropdown = ref<Record<string, boolean>>({});

const appStore = useAppStore();
const { hasClaim } = usePermissions();
const isSysAdmin = computed(() => hasClaim('admin', 'sysadmin'));

const impersonate = async (id: number) =>
{
    try {
        const tenantContext = await TokenHelper.getTenantContext();
        if (!tenantContext) {
            alert('Unable to determine tenant context.');
            return;
        }
        const response = await ApiService.startImpersonation(id, tenantContext.tenantId);
        if (response?.data?.Success && response?.data?.Token) {
            const name = response.data.ImpersonatedName || `Technician #${id}`;
            await appStore.setImpersonation(response.data.Token, name);
            window.location.reload();
        } else {
            alert('Failed to start impersonation: ' + (response?.data?.Message || 'Unknown error'));
        }
    } catch (error) {
        console.error('Impersonation error:', error);
        alert('An error occurred while starting impersonation.');
    }
};

// Selection state
const selectedRows = ref<number[]>([]);
const selectAll = ref(false);
const showDeleteModal = ref(false);

const techModel = [
    {
        name: "Select",
        label: "Select",
        type: "select",
        width: 60,
        locked: true,
        draggable: false
    },
    {
        name: "Actions",
        label: "Actions",
        type: "actions",
        overflow:true,
    }, 
    {
        name: "Id",
        display: false,
    },
    {
        name: "TechnicianName",
        label: "Name",
        display: true,
        sortable: true,
    },
    {
        name: "Email",
        label: "Email",
        display: true,
        sortable: true,
    },
    {
        name: "Active",
        label: "Active",
        display: true,
        type: "boolean",
    } 
] as Array<KtDatatableModelProp>;

const update = (val:any) =>
{
  console.debug("update", val);
};


const dismiss = () =>
{
    router.push({
        path: "/"
    });
};

const editRecord = (id: number) =>
{
    router.push({
        path: "/tech/edit/" + id
    });
};

const newRecord = () =>
{
    router.push({
        path: "/tech/edit/new"
    });
};

const refresh = async() =>
{
    Events.emit("loading", true);
    await techStore.reload();
    Events.emit("loading", false);
};

const deleteRecord = async (id: number) =>
{
    // TODO: Implement delete functionality when API is available
    console.warn("Delete functionality not yet implemented for technician ID:", id);
    // await ApiService.deleteTech(id);
    // await refresh();
};

// ===== SELECTION MANAGEMENT =====

const toggleRowSelection = (rowId: number) => {
  const index = selectedRows.value.indexOf(rowId);
  if (index > -1) {
    selectedRows.value.splice(index, 1);
  } else {
    selectedRows.value.push(rowId);
  }
  updateSelectAllState();
};

const toggleSelectAll = () => {
  if (selectAll.value) {
    selectedRows.value = [];
    selectAll.value = false;
  } else {
    selectedRows.value = listArray.value.map((row: any) => row.Id);
    selectAll.value = true;
  }
};

const updateSelectAllState = () => {
  if (listArray.value.length === 0) {
    selectAll.value = false;
    return;
  }
  const allSelected = listArray.value.every((row: any) => selectedRows.value.includes(row.Id));
  selectAll.value = allSelected;
};

const clearSelection = () => {
  selectedRows.value = [];
  selectAll.value = false;
};

// ===== BULK ACTIONS =====

const confirmBulkDelete = async () => {
  if (selectedRows.value.length === 0) return;
  
  console.warn(`Bulk delete for ${selectedRows.value.length} technician(s) - API implementation needed`);
  // TODO: Implement when API is available
  // try {
  //   for (const id of selectedRows.value) {
  //     await Api.deleteTech(id);
  //   }
  //   Alert.notify({ text: `Successfully deleted ${selectedRows.value.length} technician(s)`, type: 'success' });
  //   clearSelection();
  //   await refresh();
  // } catch (error) {
  //   console.error('Error deleting technicians:', error);
  //   Alert.notify({ text: 'Failed to delete some technicians', type: 'error' });
  // }
  
  showDeleteModal.value = false;
};

onMounted(async () =>
{
    refresh();
});


</script>

<style scoped>
/* Datatable link hover effect - blue theme with edit icon badge */
:deep(td a) {
    text-decoration: none;
    color: #333;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    position: relative;
}

:deep(td a:hover) {
    background-color: #15486A;
    color: #fff;
}

/* Edit icon badge in top-right corner on hover */
:deep(td a:hover::after) {
    content: '\f044';
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #3B9796;
    color: white;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 2px solid white;
}
</style>